import { getValue } from '../../components/values/Get';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { CustomPageValidatorFn } from '../../types/custom-page-validator';

/**
 * Custom page validation for "Angiv oplysninger om ejeren af tingen, bygningen eller dyret page"
 * Used in forms: andres-ting-bygning-dyr-oplysninger
 * At least one field in a group should be filled. There are 3 passageres groups
 * @param formValues
 * @param formConfig
 * @param pageId
 * @returns
 */
export const customPageValidation: CustomPageValidatorFn = (
    formValues: FormValues | undefined,
    formConfig: FormConfig | undefined,
    pageId: string | undefined
) => {
    if (!formValues || !formConfig) {
        return false;
    }

    const getFields = (personNumber: number) => {
        return [
            `otherInvolvedName-person${personNumber}`,
            `otherInvolvedAddress-person${personNumber}`,
            `otherInvolvedPhone-person${personNumber}`,
            `otherInvolvedInsuranceCompany-person${personNumber}`,
            `DuYouHaveInformationAboutOthersInvolvedWhichThings-person${personNumber}`
        ];
    };

    const fieldGroupsIsValid = [];

    const fieldValuesPerson1 = getFields(1).map((field: string) => getValue(formConfig, formValues, field));

    fieldGroupsIsValid.push(fieldValuesPerson1.some((value: string) => value));

    const checkboxPerson2 = getValue(
        formConfig,
        formValues,
        'doYouHaveInformationAboutOthersInvolvedAddMorePersons-addPerson2'
    );
    const person2IsSelected = checkboxPerson2.length > 0 && checkboxPerson2[0].value === 'yes';

    if (person2IsSelected) {
        const fieldValuesPerson2 = getFields(2).map((field: string) => getValue(formConfig, formValues, field));
        fieldGroupsIsValid.push(fieldValuesPerson2.some((value: string) => value));
    }

    const checkboxPerson3 = getValue(
        formConfig,
        formValues,
        'doYouHaveInformationAboutOthersInvolvedAddMorePersons-addPerson3'
    );
    const person3IsSelected = checkboxPerson3.length > 0 && checkboxPerson3[0].value === 'yes';

    if (person3IsSelected) {
        const fieldValuesPerson3 = getFields(3).map((field: string) => getValue(formConfig, formValues, field));
        fieldGroupsIsValid.push(fieldValuesPerson3.some((value: string) => value));
    }

    return fieldGroupsIsValid.every((isValid: boolean) => isValid === true);
};
